import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  cardlist: null,
  challengeslist: null,
  riverracelog: null,
  currentriverrace: null,
  currentwar: null,
  claninfo: null,
  clanlist: null,
  clanlistmembers: null,
  clanwarlog: null,
  globaltournamentlist: null,
  clanrankings: null,
  clanwarrankings: null,
  getlocations: null,
  getseasons: null,
  gettournamentranking: null,
  locationlist: null,
  seasonlist: null,
  playerranking: null,
  seasonrankings: null,
  battlelog: null,
  playersgetinfo: null,
  upcomingchests: null,
  tournamentlists: null,
  tournamentgetinfo: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const ClashRoyaleSlice = createSlice({

    name: "ClashRoyale",
    initialState: initialState,
    reducers: {
      catchError: (state, action) => {
        state.error = `${action.type}: ${action.payload.error}`;
        if (action.payload.callType === callTypes.list) {
          state.listLoading = false;
        } else {
          state.actionsLoading = false;
        }
      },
      startCall: (state, action) => {
        state.error = null;
        if (action.payload.callType === callTypes.list) {
          state.listLoading = true;
        } else {
          state.actionsLoading = true;
        }
      },
      emptyList: (state, action) => {
        state.error = null;
        state.entities = [];
        state.totalCount = 0;
      },
      cardsListFetched: (state, action) => {
        const { cardlist } = action.payload;
        state.listLoading = false;
        state.error = null;
        state.cardlist = cardlist;
      },
      challengesListFetched: (state, action) => {
        const { challengeslist } = action.payload;
        state.listLoading = false;
        state.error = null;
        state.challengeslist = challengeslist;
      },
      riverRaceLogsFetched: (state, action) => {
        const { riverracelog } = action.payload;
        state.listLoading = false;
        state.error = null;
        state.riverracelog = riverracelog;
      },
      currentRiverRaceFetched: (state, action) => {
        const { currentriverrace } = action.payload;
        state.listLoading = false;
        state.error = null;
        state.currentriverrace = currentriverrace;
      },
      currentWarFetched: (state, action) => {
        const { currentwar } = action.payload;
        state.listLoading = false;
        state.error = null;
        state.currentwar = currentwar;
      },
      clanInfoFetched: (state, action) => {
        const { claninfo } = action.payload;
        state.listLoading = false;
        state.error = null;
        state.claninfo = claninfo;
      },
      clanListFetched: (state, action) => {
        const { clanlist } = action.payload;
        state.listLoading = false;
        state.error = null;
        state.clanlist = clanlist;
      },
      clanListMembersFetched: (state, action) => {
        const { clanlistmembers } = action.payload;
        state.listLoading = false;
        state.error = null;
        state.clanlistmembers = clanlistmembers;
      },
      clanWarLogFetched: (state, action) => {
        const { clanwarlog } = action.payload;
        state.listLoading = false;
        state.error = null;
        state.clanwarlog = clanwarlog;
      },
      globalTournamentListFetched: (state, action) => {
        const { globaltournamentlist } = action.payload;
        state.listLoading = false;
        state.error = null;
        state.globaltournamentlist = globaltournamentlist;
      },
      clanWarRankingsFetched: (state, action) => {
        const { clanwarrankings } = action.payload;
        state.listLoading = false;
        state.error = null;
        state.clanwarrankings = clanwarrankings;
      },
      clanRankingsFetched: (state, action) => {
        const { clanrankings } = action.payload;
        state.listLoading = false;
        state.error = null;
        state.clanrankings = clanrankings;
      },
      getLocationsFetched: (state, action) => {
        const { getlocations } = action.payload;
        state.listLoading = false;
        state.error = null;
        state.getlocations = getlocations;
      },
      LocationListFetched: (state, action) => {
        const { locationlist } = action.payload;
        state.listLoading = false;
        state.error = null;
        state.locationlist = locationlist;
      },
      getSeasonsFetched: (state, action) => {
        const { getseasons } = action.payload;
        state.listLoading = false;
        state.error = null;
        state.getseasons = getseasons;
      },
      getTournamentRankingFetched: (state, action) => {
        const { gettournamentranking } = action.payload;
        state.listLoading = false;
        state.error = null;
        state.gettournamentranking = gettournamentranking;
      },
      playerRankingsFetched: (state, action) => {
        const { playerranking } = action.payload;
        state.listLoading = false;
        state.error = null;
        state.playerranking = playerranking;
      },
      seasonRankingFetched: (state, action) => {
        const { seasonrankings } = action.payload;
        state.listLoading = false;
        state.error = null;
        state.seasonrankings = seasonrankings;
      },
      seasonListFetched: (state, action) => {
        const { seasonlist } = action.payload;
        state.listLoading = false;
        state.error = null;
        state.seasonlist = seasonlist;
      },
      battleLogsFetched: (state, action) => {
        const { battlelog } = action.payload;
        state.listLoading = false;
        state.error = null;
        state.battlelog = battlelog;
      },
      playersGetInfoFetched: (state, action) => {
        const { playersgetinfo } = action.payload;
        state.listLoading = false;
        state.error = null;
        state.playersgetinfo = playersgetinfo;
      },
      upcomingChestsFetched: (state, action) => {
        const { upcomingchests } = action.payload;
        state.listLoading = false;
        state.error = null;
        state.upcomingchests = upcomingchests;
      },
      tournamentListFetched: (state, action) => {
        const { tournamentlist } = action.payload;
        state.listLoading = false;
        state.error = null;
        state.tournamentlist = tournamentlist;
      },
      tournamentGetInfoFetched: (state, action) => {
        const { tournamentgetinfo } = action.payload;
        state.listLoading = false;
        state.error = null;
        state.tournamentgetinfo = tournamentgetinfo;
      },
    }
  });